'use strict';
angular.module('websiteLeftModule', []).controller('websiteLeftCtrl', ['$scope', '$q', '$state', '$filter', 'editingCenterService', 'trsHttpService', 'websiteService', 'globleParamsSet', 'editingMediatype', 'websiteLeftService', 'previewToolService', '$timeout', 'trsspliceString',
    function($scope, $q, $state, $filter, editingCenterService, trsHttpService, websiteService, globleParamsSet, editingMediatype, websiteLeftService, previewToolService, $timeout, trsspliceString) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                sites: [],
                selectedSite: {},
                utilBtns: {}, // 按钮工具类
                widgets: '',
                selectedWidget: '',
                platformParam: ['waitcompiled', 'pending', 'signed'],
                isFragOpen: false, // 碎片化管理是否打开
                isPanelOpen: {
                    0: false,
                },
                expandedNode: {
                    all: [],
                    waitcompiled: [],
                    pending: [],
                    signed: [],
                },
                all: {
                    channels: '',
                    selectedChnl: '',
                    isPanelOpen: {
                        0: false,
                    },
                },
                waitcompiled: {
                    channels: '',
                    selectedChnl: '',
                    isPanelOpen: {
                        0: false,
                    },
                },
                pending: {
                    channels: '',
                    selectedChnl: '',
                    isPanelOpen: {
                        0: false,
                    },
                },
                signed: {
                    channels: '',
                    selectedChnl: '',
                    isPanelOpen: {
                        0: false,
                    },
                },
                channelTreeOptions: editingCenterService.channelTreeOptions(),
                selectChnl: '0',

            };
            initDropDownListBlur();
        }

        /**
         * [initDropDownListBlur description] 初始化下拉菜单失焦事件
         * @return {[type]} [description]
         */
        function initDropDownListBlur() {
            $('html').unbind('click', myBlur).bind('click', myBlur);

            /**
             * [myBlur description]
             * @param   {[type]}  $event  [$event description]
             * @return  {[type]}          [return description]
             */
            function myBlur($event) {
                var $target = $($event.target);
                if ($target.parents('.content_nav_select').length === 0) {
                    $timeout(function() {
                        $scope.status.isdownPicShow = false;
                    });
                }
            }

            $scope.$on('$destroy', function() {
                $('html').unbind('click', myBlur);
            });
        }

        $scope.initData = function(platform) {
            initSites().then(function() {
                changeWebPlatform(platform);
                queryCommonChannels(); // 查询已收藏的栏目
                queryWebsiteUtilBtns();
                getWebSiteAccessAuthority();
            });
        };

        /**
         * [queryCommonChannels description] 查询已收藏的栏目
         * @return {[type]} [description]
         */
        function queryCommonChannels() {
            if (angular.isDefined($scope.status.commonChannels)) {
                return;
            }
            var params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'queryCollectedChannels',
                SiteId: $scope.status.selectedSite.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.commonChannels = angular.isArray(data) ? data : [];
            });
        }

        /**
         * [cancelCommon description] 取消加入常用
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.cancelCommon = function(item) {
            var params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'deleteCollectedChannels',
                CHNLCOLLECTRELID: item.CHNLCOLLECTRELID,
            };
            $('.tooltip-arrow').remove();
            $('.tooltip-inner').remove(); // tooltip组件的坑
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                delete $scope.status.commonChannels;
                queryCommonChannels();
            });
        };

        /**
         * [queryChannelsWithoutPlat description]
         * @param   {[type]}  platform  [platform description]
         * @return  {[type]}            [return description]
         */
        function queryChannelsWithoutPlat(platform) {
            var deffer_ = $q.defer();
            initSelectedChannle();
            // 全部下没有所有栏目
            editingCenterService.queryChannelsBySiteid($scope.status.selectedSite.SITEID, platform, $scope.status.selectedPlatform !== 'all').then(function(data) {
                if (angular.isDefined(data.CHILDREN)) {
                    judgeConfigType(data.CHILDREN);
                }
                $scope.status[$scope.status.selectedPlatform].channels = data.CHILDREN;
                var routerChannelId = $scope.websiteChannelId;
                if (data.CHILDREN == undefined) {
                    $scope.status[$scope.status.selectedPlatform].selectedChnl = [];
                } else {
                    if ($scope.status.selectedPlatform === 'all' && routerChannelId === '0') {
                        $scope.status[$scope.status.selectedPlatform].selectedChnl = data.CHILDREN[0];
                    } else {
                        $scope.status[$scope.status.selectedPlatform].selectedChnl = (routerChannelId && $scope.websiteId === $scope.status.selectedSite.SITEID) ? $filter('filterBy')(data.CHILDREN, ['CHANNELID'], routerChannelId)[0] : data.CHILDREN[0];
                    }
                }
                if (angular.isDefined($scope.status[$scope.status.selectedPlatform].selectedChnl)) {
                    deffer_.resolve(data);
                } else {
                    websiteLeftService.positionSelectChannel($scope.status[$scope.status.selectedPlatform].channels, routerChannelId, platform, $scope.status.expandedNode[$scope.status.selectedPlatform])
                        .then(function(selectedChannel) {
                            $scope.status[$scope.status.selectedPlatform].selectedChnl = selectedChannel;
                            deffer_.resolve(data);
                        });
                }
            });
            return deffer_.promise;
        }

        /**
         * [getSelectedNode description] 判断栏目树中的栏目是否被选中
         * @return {[type]} [description]
         */
        $scope.getSelectedNode = function() {
            if (angular.isUndefined($scope.status.selectedPlatform)) {
                return;
            }
            if (angular.isObject($scope.status[$scope.status.selectedPlatform].selectedChnl)) {
                return $scope.status[$scope.status.selectedPlatform].selectedChnl;
            } else {
                return undefined;
            }
        };
        // 查询子节点
        $scope.queryNodeChildren = function(node) {
            if (node.CHANNELID == 0) {return;}
            var platform = $scope.status.platformParam.indexOf($scope.status.selectedPlatform) + 1;
            editingCenterService.queryChildChannel(node, platform).then(function(children) {
                if (angular.isDefined(children)) {
                    judgeConfigType(children);
                }
                node.CHILDREN = children;
            });
        };

        /**
         * [setWebSelectedChnl description] 设置网站当前选中的栏目
         * @param   {[type]}  item      [item description] 被点击对象
         * @param   {[type]}  platform  [platform description] 平台：待编，待审，已签发
         * @param   {[type]}  num       [num description]
         * @return  {[type]}            [return description]
         */
        $scope.setWebSelectedChnl = function(item, platform, num) {
            $scope.status.selectChnl = num;
            $scope.status[platform].selectedChnl = item;
            var param;
            if (angular.isObject(item)) {
                $state.go('front.editctr.website.' + platform, {
                    channelid: item.CHANNELID,
                    hasChildren: item.HASCHILDREN == 'true' ? 'true' : 'false',
                }, { reload: 'front.editctr.website.' + platform });
            } else {
                if (item === 'myshare') {
                    param = { mediatype: 2, hasChildren: item.CHILDREN ? 'true' : 'false' };
                }
                $state.go('front.editctr.website.' + platform + '.' + item, param, { reload: 'front.editctr.website.' + platform + '.' + item });
            }
        };

        /**
         * [commonChannelsIsSelected description]
         * @param {[object]} [commonChannel] [description] 常用栏目是否选中
         * @param {string} [platform] [description] 平台
         * @return {[type]} [description]
         */
        $scope.commonChannelsIsSelected = function(commonChannel, platform) {

            return commonChannel === $scope.status.waitcompiled.selectedChnl || commonChannel === $scope.status.pending.selectedChnl || commonChannel === $scope.status.signed.selectedChnl;
        };

        /**
         * [queryWebsiteUtilBtns description]查询预览、碎片化、专题等按钮
         * @return {[type]} [description]
         */
        function queryWebsiteUtilBtns() {
            if (JSON.stringify($scope.status.utilBtns) !== '{}') {
                return;
            }
            var params = {
                serviceid: 'mlf_website',
                methodname: 'queryMarksOfChnlBySite',
                SiteId: $scope.status.selectedSite.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                angular.forEach(data, function(value, key) {
                    $scope.status.utilBtns[key] = [];
                    $scope.status.utilBtnsFragment = data;
                    for (var i in value) {
                        $scope.status.utilBtns[key].push(value[i].CHANNELID || value[i].SITEID);
                    }
                });
            });
        }

        /**
         * [channelPreview description]网站栏目预览
         * @param  {[obj]} chl [description]当前栏目信息
         * @return {[type]}     [description]null
         */
        $scope.websiteChannelPreview = function(chl) {
            // websiteService.websiteChannelPreview(chl);
            previewToolService.channelPreview(chl);
            window.event.stopPropagation();
        };

        /**
         * [websiteVisualize description] 专题
         * @param  {[type]} node [description] 栏目
         * @return {[type]}      [description]
         */
        $scope.websiteVisualize = function(node) {
            $state.go('front.editctr.website.visualize', { channelid: node.CHANNELID });
            window.event.stopPropagation();
        };
        // 文件夹管理
        $scope.websiteCloud = function(node, platform) {
            $scope.setWebSelectedChnl(node, platform);
            $state.go('front.editctr.website.' + platform + '.cloud', { channelid: node.CHANNELID });
            window.event.stopPropagation();
        };

        /**
         * [changeWebPlatform description] 网站平台切换
         * @param   {[type]}  platform  [platform description]
         * @return  {[type]}            [return description]
         */
        function changeWebPlatform(platform) {
            $scope.status.selectedPlatform = platform;
            queryChannelsWithoutPlat($scope.status.platformParam.indexOf($scope.status.selectedPlatform) + 1).then(function(channels) {
                $state.go('front.editctr.website.' + platform, {
                    channelid: $scope.status[platform].selectedChnl.CHANNELID,
                    siteid: $scope.status.selectedSite.SITEID,
                    hasChildren: $scope.status[platform].selectedChnl.HASCHILDREN == 'true' ? 'true' : 'false',
                });
            });
        }

        /**
         * [initSelectedChannle description] 初始化选中栏目，用于在栏目切换时，先提前将之前所有平台的选中栏目数据删除
         * @return {[type]} [description]
         */
        function initSelectedChannle() {
            delete $scope.status.waitcompiled.selectedChnl; // 切换平台后，将不相干的平台选中数据删除
            delete $scope.status.pending.selectedChnl; // 切换平台后，将不相干的平台选中数据删除
            delete $scope.status.signed.selectedChnl; // 切换平台后，将不相干的平台选中数据删除

        }

        /**
         * [judgeConfigType 判断是否存在配置项]
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        function judgeConfigType(node) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_publishinsametime',
                methodname: 'queryRelsTypeByChannelId',
                ChannelIds: trsspliceString.spliceString(node, 'CHANNELID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                for (var i = 0; i < node.length; i++) {
                    if (data[node[i].CHANNELID] != 0) {
                        node[i].relType = data[node[i].CHANNELID];
                    }
                }
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [setWebSiteSelected description] 网站站点切换
         * @param   {[type]}  site  [site description] 被选中站点
         * @return  {[type]}        [return description]
         */
        $scope.setWebSiteSelected = function(site) {
            if ($scope.status.selectedSite === site) {
                return;
            }
            $scope.status.selectedSite = site;
            queryChannelsWithoutPlat($scope.status.platformParam.indexOf($scope.status.selectedPlatform) + 1)
                .then(function(data) {
                    if (data.HASCHILDREN === 'false') {
                        $scope.status[$scope.status.selectedPlatform].channels = [];
                        return;
                    }
                    $scope.status[$scope.status.selectedPlatform].channels = data.CHILDREN;
                    $scope.status[$scope.status.selectedPlatform].selectedChnl = data.CHILDREN[0];
                    let routerUrl = $state.$current.name;
                    routerUrl = routerUrl.includes('.cloud') ? routerUrl.replace('.cloud', '') : routerUrl;
                    $state.go(routerUrl, {
                        siteid: site.SITEID,
                        channelid: data.CHILDREN[0].CHANNELID,
                    }, { reload: routerUrl });
                });
            $scope.status.expandedNode = {
                all: [],
                waitcompiled: [],
                pending: [],
                signed: [],
            };
            delete $scope.status.websiteAccessAuthority;
            delete $scope.status.commonChannels;
            $scope.status.utilBtns = {};
            delete $scope.status.utilBtnsFragment;
            queryWebsiteUtilBtns();
            getWebSiteAccessAuthority();
            queryCommonChannels(); // 查询已收藏的栏目
        };

        /**
         * [getIwoAccessAuthority description]获取网站权限
         * @return {[type]} [description] promise
         */
        function getWebSiteAccessAuthority() {
            if (angular.isDefined($scope.status.websiteAccessAuthority)) {
                return;
            }
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryWebSiteOperTypesBySiteId',
                SiteId: $scope.status.selectedSite.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                .then(function(data) {
                    $scope.status.websiteAccessAuthority = handlePermissionData(data);
                });
        }

        /**
         * [handlePermissionData description] 处理权限数据
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function handlePermissionData(data) {
            var obj = {};
            for (var i in data) {
                var array = data[i].split('.');
                obj[array[1]] = true;
            }
            return obj;
        }

        /**
         * [websiteFragment description]已签稿的碎片化管理
         * @param  {[type]} node  [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        $scope.websiteFragment = function(node) {
            $scope.setWebSelectedChnl(node, 'signed');
            var key = node.CHANNELID ? 'CHANNELID' : 'SITEID',
                value = node.CHANNELID || node.SITEID;
            var widget = $filter('filterBy')($scope.status.utilBtnsFragment.WIDGET, [key], value)[0];
            $state.go('front.editctr.website.signed.fragmentManagement', {
                tempid: widget.TEMPID,
                objectid: widget.OBJECTID,
                objecttype: widget.OBJECTTYPE,
                siteid: node.SITEID,
                channelid: node.CHANNELID,
            }, { reload: 'front.editctr.website.signed.fragmentManagement' });
            window.event.stopPropagation();
        };

        /**
         * [addToCommon description] 添加为常用栏目
         * @param {[object]} [node] [description] 栏目数据
         * @return {[type]} [description]
         */
        $scope.addToCommon = function(node) {
            var params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'collectChannels',
                SiteId: $scope.status.selectedSite.SITEID,
                ChannelId: node.CHANNELID,
                ChnlDesc: node.CHNLDESC,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                delete $scope.status.commonChannels;
                queryCommonChannels();
            });
        };

        /**
         * [initSites description] 初始化站点
         * @return  {[type]}  [return description]
         */
        function initSites() {
            var defer = $q.defer();
            editingCenterService.querySitesByMediaType(editingMediatype.website).then(function(data) {
                $scope.status.sites = data.DATA;
                var filteredSite = $filter('filterBy')(data.DATA, ['SITEID'], $scope.websiteId);
                $timeout(function() {
                    $scope.status.selectedSite = filteredSite.length > 0 ? filteredSite[0] : data.DATA[0];
                    defer.resolve();
                });
            });
            return defer.promise;
        }

        /**
         * [siteCut description] 根据不同分辨率截取不同长度的名称
         * @param   {[type]}  site  [site description]
         * @return  {[type]}        [return description]
         */
        $scope.siteCut = function(site) {
            if (window.screen.width <= '1366') {
                site = $filter('trsLimitTo')(site, '8');
            } else if (window.screen.width <= '1680' && window.screen.width > '1366') {
                site = $filter('trsLimitTo')(site, '10');
            } else if (window.screen.width > '1680') {
                site = $filter('trsLimitTo')(site, '12');
            }
            return site;
        };
    },
]);
